import React from 'react';
import Icon from '@ant-design/icons';
import { Button } from 'antd';
import { isMediaMessage, isTextMessage } from '@whatsper/texterchat-common';
import classNames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as DeleteIcon } from '../../../../../../assets/icons/deleteIcon/deleteIcon.svg';
import { ReactComponent as EditIcon } from '../../../../../../assets/icons/pencil/penIcon.svg';
import QuickReplyPreview from '../../../../../QuickReplies/components/shared/QuickReplyPreview';
import { useStore } from '../../../../../../store/rootStore';
import styles from './QuickRepliesField.module.scss';
/** Chat-independent preview for contexts without an active chat */
export const StaticQuickReplyPreview = ({ reply, onClick }) => {
    var _a, _b;
    const first = reply.send.contents[0];
    let snippet = '';
    if (first && isTextMessage(first)) {
        snippet = first.text;
    }
    else if (first && isMediaMessage(first)) {
        snippet = ((_b = (_a = first.media) === null || _a === void 0 ? void 0 : _a.find((m) => m.caption)) === null || _b === void 0 ? void 0 : _b.caption) || React.createElement(Trans, { i18nKey: "mediaMessage" });
    }
    return (React.createElement("div", { className: classNames(styles.quickReplyMessage, styles.staticPreview), onClick: onClick },
        (reply.display.title || reply.display.note) && (React.createElement("div", { className: styles.quickReplyHeader },
            reply.display.title && React.createElement("h3", { className: styles.title }, reply.display.title),
            reply.display.note && React.createElement("p", { className: styles.description }, reply.display.note))),
        React.createElement("div", { className: styles.staticSnippet }, snippet)));
};
const QuickRepliesField = ({ reply, setReplyDeleting, isEditing, setReplyEditted }) => {
    const { activeChatStore } = useStore();
    const { t } = useTranslation();
    const handleReplyDelete = () => {
        setReplyDeleting === null || setReplyDeleting === void 0 ? void 0 : setReplyDeleting(reply, !isEditing);
    };
    const handleReplyEditted = () => {
        setReplyEditted === null || setReplyEditted === void 0 ? void 0 : setReplyEditted(reply, !isEditing);
    };
    return (React.createElement("div", { className: classNames(styles.replyParent, styles.quickRepliesField, {
            [styles.managerReply]: !!setReplyEditted,
            [styles.quickRepliesFieldActive]: isEditing,
        }) },
        React.createElement("div", { className: styles.replyEditAction, role: "button", tabIndex: 0, "aria-label": t('editQuickReply'), onClick: handleReplyEditted, onKeyDown: (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    handleReplyEditted();
                }
            } }, activeChatStore.chat ? (React.createElement(QuickReplyPreview, { quickReply: reply, className: styles.quickReplyMessage, messageClassName: classNames(styles.messageItem, styles.quickReplyMessagePreview) })) : (React.createElement(StaticQuickReplyPreview, { reply: reply }))),
        React.createElement("div", { className: styles.replyNameSpaceRight },
            React.createElement(Button, { type: "text", className: styles.replyNameButtonEdit, icon: React.createElement(Icon, { component: EditIcon }), onClick: handleReplyEditted, "aria-label": t('editQuickReply'), title: t('editQuickReply') }),
            React.createElement(Button, { type: "text", className: styles.replyNameButtonDelete, icon: React.createElement(Icon, { component: DeleteIcon }), onClick: handleReplyDelete, "aria-label": t('delete'), title: t('delete') }))));
};
export default QuickRepliesField;
